// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3x_WC","label":"LabeledBox_label__3XPjr"};